export default __webpack_public_path__ + "static/media/pic34-before.1747b46c.jpg";